import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2/icon';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import type {InfoBoxProps} from './info-box.types';
import styles from './info-box.module.scss';

export function InfoBox({descriptor}: InfoBoxProps): ReactElement {
  return (
    <div className={`${styles.infoBox} bg-warning-secondary-default flex-h-row flex-items-start gap-2 spacing-p-2 corner-radius-8`}>
      <Icon icon="icon-exclamation-triangle" size={IconSize.SIZE_ICON_16} className={`ct-warning-primary flex-shrink-0 ${styles.icon}`} ariaHidden />
      <Text className="ct-warning-primary flex-1" dangerouslySetInnerHTML size={TextSize.MD} val={window.i18next.t(descriptor.contentKey)} />
    </div>
  );
}
